import React from "react";
import PropTypes from "prop-types";
import { useMutation } from "@apollo/client";
import { useTranslation } from "react-i18next";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogActions from "@mui/material/DialogActions";
import Button from "@mui/material/Button";
import { UpdateSettingsMutation } from "arena/mutations";

export default function AgeConfirmationDialog({
  open,
  onClose,
  onConfirm,
  age,
}) {
  const { t } = useTranslation("arena");

  const [updateSettings, { loading }] = useMutation(UpdateSettingsMutation);

  const handleConfirm = async () => {
    await updateSettings({ variables: { input: { ageConfirmed: age } } });
    onConfirm();
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth>
      <DialogTitle>{t("book.ageConfirmation.title")}</DialogTitle>
      <DialogContent>
        <DialogContentText>
          {t("book.ageConfirmation.text", { age })}
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} disabled={loading}>
          {t("book.ageConfirmation.cancel")}
        </Button>
        <Button
          variant="contained"
          onClick={handleConfirm}
          disabled={loading}
          autoFocus
        >
          {t("book.ageConfirmation.confirm")}
        </Button>
      </DialogActions>
    </Dialog>
  );
}

AgeConfirmationDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired,
  age: PropTypes.number.isRequired,
};
